import {onDomReady} from "./observer.js";

class Sidebar {
    constructor() {
        this.options = {
            sidebarTrigger: '[data-sidebar-trigger]',
            // sidebarClass: 'sidebar',
            sidebarOpenedClass: 'sidebar_opened',
            sidebarNoir: '[data-sidebar-noir]',
            sidebarClose: '[data-sidebar-close]',
            // popupPreopenedClass: 'popup-window_preopened',
        };

        this.elements = {
            sidebarTrigger: document.querySelectorAll(this.options.sidebarTrigger),
        };

        this.init();
    }

    // sidebarTrigger - button for sidebar open event
    // sidebarWindows - target div to be opened

    init() {

        if (this.elements.sidebarTrigger) {
            const sidebarTriggerElements = this.elements.sidebarTrigger;
            sidebarTriggerElements.forEach((sidebarTriggerCurrent) => {

                sidebarTriggerCurrent.addEventListener('click', (event) => {

                    const triggerValueCurrent = sidebarTriggerCurrent.getAttribute('data-sidebar-trigger');
                    const sidebarWindowCurrent = document.querySelector(`[data-sidebar-window="${triggerValueCurrent}"]`);

                    if (sidebarWindowCurrent) {
                        const sidebarWindowCurrentNoir = sidebarWindowCurrent.querySelector(this.options.sidebarNoir);

                        if (sidebarWindowCurrentNoir) {
                            sidebarWindowCurrent.classList.toggle(this.options.sidebarOpenedClass);
                            // sidebarWindowCurrent.classList.add(this.options.sidebarOpenedClass);

                            sidebarWindowCurrentNoir.addEventListener('click', (event) => {
                                sidebarWindowCurrent.classList.remove(this.options.sidebarOpenedClass);
                            });
                        }

                        const sidebarWindowCloses = sidebarWindowCurrent.querySelectorAll(this.options.sidebarClose);
                        if (sidebarWindowCloses) {
                            sidebarWindowCloses.forEach((sidebarWindowCurrentClose) => {
                                sidebarWindowCurrentClose.addEventListener('click', (event) => {
                                    sidebarWindowCurrent.classList.remove(this.options.sidebarOpenedClass);
                                });
                            });
                        }
                    }

                });
            });
        }

    }
}

onDomReady(() => {
    const header = new Sidebar();
}, false);